import React, {useCallback} from "react";
import {useSocket} from "../hooks";
import {useAuth} from "../context/AuthContext";
import {showMessageNotification} from "../utils/notificationService";
import {useNavigate} from "react-router-dom";
import {imageCache} from "../components/Image";
import {chatAPI} from "../services/api";

const GlobalSocketHandler: React.FC = () => {
    const navigate = useNavigate();
    const { socket } = useSocket();
    const { user } = useAuth();

    const getAvatarUrl = (path: string) => {
        if (imageCache.has(path)) {
            return imageCache.get(path)!;
        }
    }

    const handleNewMessage = useCallback(async (message: any) => {
        if (message.sender_id !== user?.id) {
            let url = getAvatarUrl(message.sender_avatar_url);
            if (!url && message.sender_avatar_url) {
                const rs = await chatAPI.downloadFile(message.sender_avatar_url);
                url = window.URL.createObjectURL(rs);
            }
            await showMessageNotification({
                sender_name: message.sender_nickname || message.sender_name || '',
                sender_avatar: url,
                message_body: message.message_body
                    ? message.message_body
                    : 'が添付ファイルを送信しました',
                conversation_id: message.conversation_id,
                onClick: () => {
                    navigate(`/admin/dashboard`);
                }
            });
        }
    }, [navigate, user?.id]);

    React.useEffect(() => {
        if (!socket) return;

        socket.on('notifyMessage', handleNewMessage);

        return () => {
            socket.off('notifyMessage', handleNewMessage);
        };
    }, [handleNewMessage, socket]);

    return null;
};

export default React.memo(GlobalSocketHandler);